module.exports = __webpack_public_path__ + "img/excel1.5e91abe0.jpg";